import gql from 'graphql-tag';

export default gql`
  query {
    userApplicationsTeachersAid {
      status
      applicationTeachersAidId
      termFormattedShort
      term {
        year
      }
      school {
        name
      }
    }
  }
`;
